/* eslint-disable */
import * as Types from '../../../../../types';

import { gql } from '@apollo/client';
import { FormattedCurrencyTextCurrencyFieldsFragmentDoc, FormattedCurrencyTextMoneyFieldsFragmentDoc } from '../../../../../components/organisms/FormattedCurrencyText/FormattedCurrencyText.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OfferAllocationRequestDetailsFragment = { __typename: 'Offer', id: string, slug: string, name: string, status: Types.OfferStatus, digitalSubscription: Types.OfferDigitalSubscription, pricePerUnit?: number | null, estimatedPricePerUnit?: number | null, totalUnitCountDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, minUnitsPerInvestmentDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, maxUnitsPerInvestmentDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, primaryDocument?: { __typename: 'RemoteAsset', id: string, url: string } | null, investor?: { __typename: 'OfferInvestor', outstandingRequirementsToInvest: Array<Types.OutstandingRequirementToInvest> } | null, fund: { __typename: 'Fund', id: string, name: string, unitPrecisionScale?: number | null, currency: { __typename: 'Currency', id: string, abbreviation: string, symbol: string, decimalSeparator: string, thousandsSeparator: string } }, applicationProgress?: { __typename: 'ApplicationProgress', investingEntityId?: string | null, completedSteps: Array<Types.ApplicationStep | null>, activeStep?: Types.ApplicationStep | null, investorPreference?: string | null, unitCountDecimal?: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number } | null } | null };

export type ApplicationProgressSidebarFragment = { __typename: 'Offer', id: string, slug: string, name: string, status: Types.OfferStatus, digitalSubscription: Types.OfferDigitalSubscription, pricePerUnit?: number | null, estimatedPricePerUnit?: number | null, minUnitsPerInvestmentDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, primaryDocument?: { __typename: 'RemoteAsset', id: string, url: string } | null, fund: { __typename: 'Fund', id: string, name: string, unitPrecisionScale?: number | null, currency: { __typename: 'Currency', id: string, abbreviation: string, symbol: string, decimalSeparator: string, thousandsSeparator: string } }, applicationProgress?: { __typename: 'ApplicationProgress', investingEntityId?: string | null, completedSteps: Array<Types.ApplicationStep | null>, activeStep?: Types.ApplicationStep | null, unitCountDecimal?: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number } | null } | null };

export type OfferAllocationRequestDetailsQueryVariables = Types.Exact<{
  slug: Types.Scalars['ID'];
  skipSession?: Types.Scalars['Boolean'];
}>;


export type OfferAllocationRequestDetailsQuery = { __typename: 'Query', offer?: { __typename: 'Offer', id: string, slug: string, name: string, status: Types.OfferStatus, digitalSubscription: Types.OfferDigitalSubscription, pricePerUnit?: number | null, estimatedPricePerUnit?: number | null, totalUnitCountDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, minUnitsPerInvestmentDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, maxUnitsPerInvestmentDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, primaryDocument?: { __typename: 'RemoteAsset', id: string, url: string } | null, investor?: { __typename: 'OfferInvestor', outstandingRequirementsToInvest: Array<Types.OutstandingRequirementToInvest> } | null, fund: { __typename: 'Fund', id: string, name: string, unitPrecisionScale?: number | null, currency: { __typename: 'Currency', id: string, abbreviation: string, symbol: string, decimalSeparator: string, thousandsSeparator: string } }, applicationProgress?: { __typename: 'ApplicationProgress', investingEntityId?: string | null, completedSteps: Array<Types.ApplicationStep | null>, activeStep?: Types.ApplicationStep | null, investorPreference?: string | null, unitCountDecimal?: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number } | null } | null } | null, session?: { __typename: 'Session', impersonatedBy?: { __typename: 'Admin', id: string } | null } | null };

export type ActiveInvestorDetailsFragment = { __typename: 'Account', id: string, activeInvestingEntity?: { __typename: 'InvestingEntity', id: string, name?: string | null, bankAccounts: Array<{ __typename: 'AUDVerifiableBankAccount', id: string } | { __typename: 'EURVerifiableBankAccount', id: string } | { __typename: 'GBPVerifiableBankAccount', id: string } | { __typename: 'NZDVerifiableBankAccount', id: string } | { __typename: 'USDVerifiableBankAccount', id: string } | { __typename: 'VerifiableBankAccountImpl', id: string }> } | null, investingEntities?: Array<{ __typename: 'InvestingEntity', id: string, name?: string | null, entityTypeEnum: Types.InvestingEntityType, bankAccounts: Array<{ __typename: 'AUDVerifiableBankAccount', id: string } | { __typename: 'EURVerifiableBankAccount', id: string } | { __typename: 'GBPVerifiableBankAccount', id: string } | { __typename: 'NZDVerifiableBankAccount', id: string } | { __typename: 'USDVerifiableBankAccount', id: string } | { __typename: 'VerifiableBankAccountImpl', id: string }> }> | null };

export type InvestorDetailsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InvestorDetailsQuery = { __typename: 'Query', account?: { __typename: 'Account', id: string, activeInvestingEntity?: { __typename: 'InvestingEntity', id: string, name?: string | null, bankAccounts: Array<{ __typename: 'AUDVerifiableBankAccount', id: string } | { __typename: 'EURVerifiableBankAccount', id: string } | { __typename: 'GBPVerifiableBankAccount', id: string } | { __typename: 'NZDVerifiableBankAccount', id: string } | { __typename: 'USDVerifiableBankAccount', id: string } | { __typename: 'VerifiableBankAccountImpl', id: string }> } | null, investingEntities?: Array<{ __typename: 'InvestingEntity', id: string, name?: string | null, entityTypeEnum: Types.InvestingEntityType, bankAccounts: Array<{ __typename: 'AUDVerifiableBankAccount', id: string } | { __typename: 'EURVerifiableBankAccount', id: string } | { __typename: 'GBPVerifiableBankAccount', id: string } | { __typename: 'NZDVerifiableBankAccount', id: string } | { __typename: 'USDVerifiableBankAccount', id: string } | { __typename: 'VerifiableBankAccountImpl', id: string }> }> | null } | null };

export type CreateAccountWithAdditionalDetailsMutationVariables = Types.Exact<{
  account: Types.CreateAccountInput;
}>;


export type CreateAccountWithAdditionalDetailsMutation = { __typename: 'Mutation', createAccount?: { __typename: 'NewSession', account: { __typename: 'Account', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, preferredName?: string | null, email?: string | null, timeZone?: string | null, frontChatHash?: string | null, isAccountLocked?: boolean | null, accountLockedReason?: string | null, hasProvidedAccountDetails: boolean }, features: Array<{ __typename: 'FeatureFlag', name: string, isEnabled: boolean }>, session: { __typename: 'Session', id: string, token: any, expires: any, impersonatedBy?: { __typename: 'Admin', id: string, firstName: string, lastName: string } | null } } | null };

export type IsAllocationDisabledQueryVariables = Types.Exact<{
  slug: Types.Scalars['ID'];
}>;


export type IsAllocationDisabledQuery = { __typename: 'Query', offer?: { __typename: 'Offer', id: string, digitalSubscription: Types.OfferDigitalSubscription } | null };

export const OfferAllocationRequestDetailsFragmentDoc = gql`
    fragment OfferAllocationRequestDetails on Offer {
  id
  slug
  name
  status
  digitalSubscription
  pricePerUnit
  estimatedPricePerUnit
  totalUnitCountDecimal {
    value
    decimalPlaces
  }
  minUnitsPerInvestmentDecimal {
    value
    decimalPlaces
  }
  maxUnitsPerInvestmentDecimal {
    value
    decimalPlaces
  }
  primaryDocument {
    id
    url
  }
  investor {
    outstandingRequirementsToInvest
  }
  fund {
    id
    name
    unitPrecisionScale
    currency {
      ...FormattedCurrencyTextCurrencyFields
    }
  }
  applicationProgress @client {
    investingEntityId
    completedSteps
    activeStep
    unitCountDecimal {
      value
      decimalPlaces
    }
    investorPreference
  }
}
    ${FormattedCurrencyTextCurrencyFieldsFragmentDoc}`;
export const ApplicationProgressSidebarFragmentDoc = gql`
    fragment ApplicationProgressSidebar on Offer {
  id
  slug
  name
  status
  digitalSubscription
  pricePerUnit
  estimatedPricePerUnit
  minUnitsPerInvestmentDecimal {
    value
    decimalPlaces
  }
  primaryDocument {
    id
    url
  }
  fund {
    id
    name
    unitPrecisionScale
    currency {
      ...FormattedCurrencyTextCurrencyFields
    }
  }
  applicationProgress @client {
    investingEntityId
    completedSteps
    activeStep
    unitCountDecimal {
      value
      decimalPlaces
    }
  }
}
    ${FormattedCurrencyTextCurrencyFieldsFragmentDoc}`;
export const ActiveInvestorDetailsFragmentDoc = gql`
    fragment ActiveInvestorDetails on Account {
  id
  activeInvestingEntity {
    id
    name
    bankAccounts {
      id
    }
  }
  investingEntities {
    id
    name
    entityTypeEnum
    bankAccounts {
      id
    }
  }
}
    `;
export const OfferAllocationRequestDetailsDocument = gql`
    query OfferAllocationRequestDetails($slug: ID!, $skipSession: Boolean! = true) {
  offer(slug: $slug) {
    id
    ...OfferAllocationRequestDetails
  }
  session @skip(if: $skipSession) {
    impersonatedBy {
      id
    }
  }
}
    ${OfferAllocationRequestDetailsFragmentDoc}`;

/**
 * __useOfferAllocationRequestDetailsQuery__
 *
 * To run a query within a React component, call `useOfferAllocationRequestDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferAllocationRequestDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferAllocationRequestDetailsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      skipSession: // value for 'skipSession'
 *   },
 * });
 */
export function useOfferAllocationRequestDetailsQuery(baseOptions: Apollo.QueryHookOptions<OfferAllocationRequestDetailsQuery, OfferAllocationRequestDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferAllocationRequestDetailsQuery, OfferAllocationRequestDetailsQueryVariables>(OfferAllocationRequestDetailsDocument, options);
      }
export function useOfferAllocationRequestDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferAllocationRequestDetailsQuery, OfferAllocationRequestDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferAllocationRequestDetailsQuery, OfferAllocationRequestDetailsQueryVariables>(OfferAllocationRequestDetailsDocument, options);
        }
export type OfferAllocationRequestDetailsQueryHookResult = ReturnType<typeof useOfferAllocationRequestDetailsQuery>;
export type OfferAllocationRequestDetailsLazyQueryHookResult = ReturnType<typeof useOfferAllocationRequestDetailsLazyQuery>;
export type OfferAllocationRequestDetailsQueryResult = Apollo.QueryResult<OfferAllocationRequestDetailsQuery, OfferAllocationRequestDetailsQueryVariables>;
export const InvestorDetailsDocument = gql`
    query InvestorDetails {
  account {
    ...ActiveInvestorDetails
  }
}
    ${ActiveInvestorDetailsFragmentDoc}`;

/**
 * __useInvestorDetailsQuery__
 *
 * To run a query within a React component, call `useInvestorDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestorDetailsQuery(baseOptions?: Apollo.QueryHookOptions<InvestorDetailsQuery, InvestorDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorDetailsQuery, InvestorDetailsQueryVariables>(InvestorDetailsDocument, options);
      }
export function useInvestorDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorDetailsQuery, InvestorDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorDetailsQuery, InvestorDetailsQueryVariables>(InvestorDetailsDocument, options);
        }
export type InvestorDetailsQueryHookResult = ReturnType<typeof useInvestorDetailsQuery>;
export type InvestorDetailsLazyQueryHookResult = ReturnType<typeof useInvestorDetailsLazyQuery>;
export type InvestorDetailsQueryResult = Apollo.QueryResult<InvestorDetailsQuery, InvestorDetailsQueryVariables>;
export const CreateAccountWithAdditionalDetailsDocument = gql`
    mutation CreateAccountWithAdditionalDetails($account: CreateAccountInput!) {
  createAccount(account: $account) {
    account {
      id
      firstName
      middleName
      lastName
      preferredName
      email
      timeZone
      frontChatHash
      isAccountLocked
      accountLockedReason
      hasProvidedAccountDetails
    }
    features {
      name
      isEnabled
    }
    session {
      id
      token
      expires
      impersonatedBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export type CreateAccountWithAdditionalDetailsMutationFn = Apollo.MutationFunction<CreateAccountWithAdditionalDetailsMutation, CreateAccountWithAdditionalDetailsMutationVariables>;

/**
 * __useCreateAccountWithAdditionalDetailsMutation__
 *
 * To run a mutation, you first call `useCreateAccountWithAdditionalDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountWithAdditionalDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountWithAdditionalDetailsMutation, { data, loading, error }] = useCreateAccountWithAdditionalDetailsMutation({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useCreateAccountWithAdditionalDetailsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountWithAdditionalDetailsMutation, CreateAccountWithAdditionalDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountWithAdditionalDetailsMutation, CreateAccountWithAdditionalDetailsMutationVariables>(CreateAccountWithAdditionalDetailsDocument, options);
      }
export type CreateAccountWithAdditionalDetailsMutationHookResult = ReturnType<typeof useCreateAccountWithAdditionalDetailsMutation>;
export type CreateAccountWithAdditionalDetailsMutationResult = Apollo.MutationResult<CreateAccountWithAdditionalDetailsMutation>;
export type CreateAccountWithAdditionalDetailsMutationOptions = Apollo.BaseMutationOptions<CreateAccountWithAdditionalDetailsMutation, CreateAccountWithAdditionalDetailsMutationVariables>;
export const IsAllocationDisabledDocument = gql`
    query IsAllocationDisabled($slug: ID!) {
  offer(slug: $slug) {
    id
    digitalSubscription
  }
}
    `;

/**
 * __useIsAllocationDisabledQuery__
 *
 * To run a query within a React component, call `useIsAllocationDisabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAllocationDisabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAllocationDisabledQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useIsAllocationDisabledQuery(baseOptions: Apollo.QueryHookOptions<IsAllocationDisabledQuery, IsAllocationDisabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsAllocationDisabledQuery, IsAllocationDisabledQueryVariables>(IsAllocationDisabledDocument, options);
      }
export function useIsAllocationDisabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsAllocationDisabledQuery, IsAllocationDisabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsAllocationDisabledQuery, IsAllocationDisabledQueryVariables>(IsAllocationDisabledDocument, options);
        }
export type IsAllocationDisabledQueryHookResult = ReturnType<typeof useIsAllocationDisabledQuery>;
export type IsAllocationDisabledLazyQueryHookResult = ReturnType<typeof useIsAllocationDisabledLazyQuery>;
export type IsAllocationDisabledQueryResult = Apollo.QueryResult<IsAllocationDisabledQuery, IsAllocationDisabledQueryVariables>;